import { DOMAIN_NAME } from './common';

// Template Actions
export const FETCH_TEMPLATES = `${DOMAIN_NAME}/FETCH_TEMPLATES`;
export const FETCH_TEMPLATES_SUCCESS = `${DOMAIN_NAME}/FETCH_TEMPLATES_SUCCESS`;
export const FETCH_TEMPLATES_FAILURE = `${DOMAIN_NAME}/FETCH_TEMPLATES_FAILURE`;

export const FETCH_TEMPLATE_WITH_GOALS = `${DOMAIN_NAME}/FETCH_TEMPLATE_WITH_GOALS`;
export const FETCH_TEMPLATE_WITH_GOALS_SUCCESS = `${DOMAIN_NAME}/FETCH_TEMPLATE_WITH_GOALS_SUCCESS`;
export const FETCH_TEMPLATE_WITH_GOALS_FAILURE = `${DOMAIN_NAME}/FETCH_TEMPLATE_WITH_GOALS_FAILURE`;

export const CREATE_TEMPLATE = `${DOMAIN_NAME}/CREATE_TEMPLATE`;
export const CREATE_TEMPLATE_SUCCESS = `${DOMAIN_NAME}/CREATE_TEMPLATE_SUCCESS`;
export const CREATE_TEMPLATE_FAILURE = `${DOMAIN_NAME}/CREATE_TEMPLATE_FAILURE`;

export const UPDATE_TEMPLATE = `${DOMAIN_NAME}/UPDATE_TEMPLATE`;
export const UPDATE_TEMPLATE_SUCCESS = `${DOMAIN_NAME}/UPDATE_TEMPLATE_SUCCESS`;
export const UPDATE_TEMPLATE_FAILURE = `${DOMAIN_NAME}/UPDATE_TEMPLATE_FAILURE`;

export const DELETE_TEMPLATE = `${DOMAIN_NAME}/DELETE_TEMPLATE`;
export const DELETE_TEMPLATE_SUCCESS = `${DOMAIN_NAME}/DELETE_TEMPLATE_SUCCESS`;
export const DELETE_TEMPLATE_FAILURE = `${DOMAIN_NAME}/DELETE_TEMPLATE_FAILURE`;

// Goal Management Actions
export const FETCH_ALL_GOALS = `${DOMAIN_NAME}/FETCH_ALL_GOALS`;
export const FETCH_ALL_GOALS_SUCCESS = `${DOMAIN_NAME}/FETCH_ALL_GOALS_SUCCESS`;
export const FETCH_ALL_GOALS_FAILURE = `${DOMAIN_NAME}/FETCH_ALL_GOALS_FAILURE`;

// Department Actions
export const FETCH_DEPARTMENTS = `${DOMAIN_NAME}/FETCH_DEPARTMENTS`;
export const FETCH_DEPARTMENTS_SUCCESS = `${DOMAIN_NAME}/FETCH_DEPARTMENTS_SUCCESS`;
export const FETCH_DEPARTMENTS_FAILURE = `${DOMAIN_NAME}/FETCH_DEPARTMENTS_FAILURE`;

export const ADD_GOAL_TO_TEMPLATE = `${DOMAIN_NAME}/ADD_GOAL_TO_TEMPLATE`;
export const ADD_GOAL_TO_TEMPLATE_SUCCESS = `${DOMAIN_NAME}/ADD_GOAL_TO_TEMPLATE_SUCCESS`;
export const ADD_GOAL_TO_TEMPLATE_FAILURE = `${DOMAIN_NAME}/ADD_GOAL_TO_TEMPLATE_FAILURE`;

export const UPDATE_TEMPLATE_GOAL = `${DOMAIN_NAME}/UPDATE_TEMPLATE_GOAL`;
export const UPDATE_TEMPLATE_GOAL_SUCCESS = `${DOMAIN_NAME}/UPDATE_TEMPLATE_GOAL_SUCCESS`;
export const UPDATE_TEMPLATE_GOAL_FAILURE = `${DOMAIN_NAME}/UPDATE_TEMPLATE_GOAL_FAILURE`;

export const REMOVE_GOAL_FROM_TEMPLATE = `${DOMAIN_NAME}/REMOVE_GOAL_FROM_TEMPLATE`;
export const REMOVE_GOAL_FROM_TEMPLATE_SUCCESS = `${DOMAIN_NAME}/REMOVE_GOAL_FROM_TEMPLATE_SUCCESS`;
export const REMOVE_GOAL_FROM_TEMPLATE_FAILURE = `${DOMAIN_NAME}/REMOVE_GOAL_FROM_TEMPLATE_FAILURE`;

// Dialog Actions
export const OPEN_TEMPLATE_DIALOG = `${DOMAIN_NAME}/OPEN_TEMPLATE_DIALOG`;
export const CLOSE_TEMPLATE_DIALOG = `${DOMAIN_NAME}/CLOSE_TEMPLATE_DIALOG`;

export const OPEN_GOAL_DIALOG = `${DOMAIN_NAME}/OPEN_GOAL_DIALOG`;
export const CLOSE_GOAL_DIALOG = `${DOMAIN_NAME}/CLOSE_GOAL_DIALOG`;

export const OPEN_MANAGE_GOALS_DIALOG = `${DOMAIN_NAME}/OPEN_MANAGE_GOALS_DIALOG`;
export const CLOSE_MANAGE_GOALS_DIALOG = `${DOMAIN_NAME}/CLOSE_MANAGE_GOALS_DIALOG`;

export const OPEN_DELETE_DIALOG = `${DOMAIN_NAME}/OPEN_DELETE_DIALOG`;
export const CLOSE_DELETE_DIALOG = `${DOMAIN_NAME}/CLOSE_DELETE_DIALOG`;

export const OPEN_DELETE_GOAL_DIALOG = `${DOMAIN_NAME}/OPEN_DELETE_GOAL_DIALOG`;
export const CLOSE_DELETE_GOAL_DIALOG = `${DOMAIN_NAME}/CLOSE_DELETE_GOAL_DIALOG`;

// Filter and Pagination Actions
export const SET_FILTERS = `${DOMAIN_NAME}/SET_FILTERS`;
export const SET_PAGINATION = `${DOMAIN_NAME}/SET_PAGINATION`;
export const SET_SORT = `${DOMAIN_NAME}/SET_SORT`;
